var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoZendesk = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 40,
    viewBox: "0 0 53 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0545 0C25.0545 7.00459 19.4459 12.6829 12.5273 12.6829C5.60865 12.6829 0 7.00459 0 0H25.0545Z",
    fill: "#722B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9455 40C27.9455 32.9954 33.5541 27.3171 40.4727 27.3171C47.3913 27.3171 53 32.9954 53 40L27.9455 40Z",
    fill: "#722B2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9455 29.2683V0H53L27.9455 29.2683Z",
    fill: "#722B2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0545 10.7317L25.0545 40L0 40L25.0545 10.7317Z",
    fill: "#722B2B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoZendesk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_zendesk.90fb8f45e2a35debc61554d5547d89e8.svg";